/* eslint-disable */
import Vue from 'vue'
import pick from 'lodash/pick'
import get from 'lodash/get'
import { getGraphql } from '../static/graphql/getGraphql.js'

export const state = () => ({
  loading: [],
  memberPayments: [],
  paginatedMemberPayments: {},
  futurePayout: undefined,
  futurePayments: [],
  pastPayments: [],
  totalMemberPayments: 0,
  stripeIssuingBalance: 0,
  paymentAccounts: undefined,
  selectedMemberPayment: undefined,
  usioEntityPayment: undefined,
  accountLogin: undefined,
})

export const mutations = {
  setLoading(state, payload) {
    state.loading.push(payload.key)

    // unique the array
    state.loading = [...new Set(state.loading)]

    // remove
    if (!payload.value) {
      state.loading = state.loading.filter((e) => e !== payload.key)
    }
  },
  clearData(state) {
    state.loading = []
    state.memberPayments = []
    state.totalMemberPayments = 0
    state.stripeIssuingBalance = 0
    state.futurePayments = []
    state.pastPayments = []
    state.futurePayout = undefined
    state.selectedMemberPayment = undefined
  },
  clearSelectedMemberPayment(state) {
    state.loading = []
    state.selectedMemberPayment = undefined
  },
  clearMemberPayments(state) {
    state.loading = []
    state.memberPayments = []
    state.paginatedMemberPayments = {}
    state.totalMemberPayments = 0
  },
  setTotalMemberPayments(state, payload) {
    state.totalMemberPayments = payload
  },
  setPaymentAccounts(state, payload) {
    state.paymentAccounts = payload
  },
  setFuturePayout(state, payload) {
    if (payload !== undefined) {
      const mp = payload
      const payoutData = {
        memberPaymentUuid: mp.paymentUuid,
        dateWaitUntil: mp.datePaymentFulfilled,
        meta: {},
        targetEntityUuid: mp.memberEntityUuid,
        amount: mp.amount,
        withdrawalReason: '',
        paymentType: 'ongoing_fund_payment', // TODO: map from campaign's payment
        sourceNameFriendly: mp.contract.name,
        idempotencyKey: '',
        status: mp.paymentStatus.name,
        externalId: '',
        entityPaymentUuid: '',
        paymentMethod: '',
        paymentDate: mp.datePaymentFulfilled,
        payoutDate: mp.datePaymentFulfilled,
      }
      state.futurePayout = payoutData
    }
  },
  setStripeIssuingBalance(state, payload) {
    state.stripeIssuingBalance = payload
  },
  setSelectedPayout(state, payload) {
    state.selectedMemberPayment = payload
  },
  addMemberPayment(state, payload) {
    const mp = payload.memberPayment

    state.memberPayments.push(
      pick(mp, [
        'memberPaymentUuid',
        'withdrawalReason',
        'amount',
        'status',
        'externalId',
        'dateCreated',
        'targetEntityUuid',
        'paymentMethod',
      ])
    )
  },
  addPaginatedMemberPaymentPage(state, payload) {
    const { page, memberPayments } = payload
    Vue.set(state.paginatedMemberPayments, page, memberPayments)
  },
  addPastPayment(state, payload) {
    const mp = payload.memberPayment

    state.pastPayments.push(
      pick(mp, [
        'memberPaymentUuid',
        'withdrawalReason',
        'amount',
        'status',
        'externalId',
        'dateCreated',
        'targetEntityUuid',
      ])
    )
  },
  addFuturePayment(state, payload) {
    const mp = payload.memberPayment

    state.futurePayments.push({
      memberPaymentUuid: mp.paymentUuid,
      dateWaitUntil: mp.datePaymentFulfilled,
      meta: {},
      targetEntityUuid: mp.memberEntityUuid,
      amount: mp.amount,
      withdrawalReason: '',
      paymentType: 'ongoing_fund_payment', // TODO: map from campaign's payment
      sourceNameFriendly: mp.contract.name,
      idempotencyKey: '',
      status: mp.paymentStatus.name,
      externalId: '',
      entityPaymentUuid: '',
      paymentMethod: '',
      paymentDate: mp.datePaymentFulfilled,
      payoutDate: mp.datePaymentFulfilled,
    })
  },
  setUsioEntityPayment(state, payload) {
    state.usioEntityPayment = payload
  },

  setAccountLogin(state, payload) {
    state.accountLogin = payload
  },
}

export const actions = {
  async getPaginatedMemberPayments(
    context,
    { page, limit = 10, clearCache = false }
  ) {
    if (clearCache) {
      context.commit('clearMemberPayments')
    }

    context.commit('setLoading', { key: 'getMemberPayments', value: true })
    const offset = (page - 1) * limit
    const variables = { limit, offset }

    try {
      const query = await getGraphql('my-member-payments.graphql')
      const response = await this.$axios.$post('/GRAPHQL_URL/', {
        query,
        variables,
      })

      const memberPayments = (
        response.data.me.memberPayments.results || []
      ).map((mp) =>
        pick(mp, [
          'memberPaymentUuid',
          'withdrawalReason',
          'amount',
          'status',
          'externalId',
          'dateCreated',
          'targetEntityUuid',
          'paymentMethod',
        ])
      )
      const totalCount = response.data.me.memberPayments.totalCount
      context.commit('setTotalMemberPayments', totalCount)
      context.commit('addPaginatedMemberPaymentPage', { page, memberPayments })
    } catch (error) {
      console.log('Error getting memberPayments', error)
    } finally {
      context.commit('setLoading', { key: 'getMemberPayments', value: false })
    }
  },
  async getPaymentAccounts(context, activeEntity) {
    /*
    Action to retrieve configured payment methods for a member
     */
    context.commit('setLoading', { key: 'getPaymentAccounts', value: true })
    try {
      const accounts = await this.$axios.$get(
        `/PROFILE_URL/me/payments/product/accounts`
      )
      const virtualWalletArray = []
      // eslint-disable
      for (let account = 0; account < accounts.length; account++) {
        const element = accounts[account]
        if (
          element.vendor_product.toLowerCase() === 'usio akimbo virtual wallet'
        ) {
          const cardId = get(element, [
            'entity_payment',
            'meta',
            'card',
            'card_id',
          ])

          if (cardId != null) {
            virtualWalletArray.push(element)
          }
        }
      }
      const account = []
      if (virtualWalletArray[0]) account.push(virtualWalletArray[0])
      context.commit('setPaymentAccounts', account)
      return account
    } catch (error) {
      console.error('Error fetching payment accounts:', error)
    } finally {
      context.commit('setLoading', { key: 'getPaymentAccounts', value: false })
    }
  },
  async getMemberPayments(context, variables) {
    try {
      context.commit('clearMemberPayments')
      context.commit('setLoading', { key: 'getMemberPayments', value: true })

      const query = await getGraphql('my-member-payments.graphql')
      const response = await this.$axios.$post('/GRAPHQL_URL/', {
        query,
        variables,
      })

      // parse individual memberPayments
      const memberPayments = response.data.me.memberPayments.results
      const totalCount = response.data.me.memberPayments.totalCount
      context.commit('setTotalMemberPayments', totalCount)
      if (memberPayments && memberPayments.length > 0) {
        for (let j = 0; j < memberPayments.length; j++) {
          context.commit('addMemberPayment', {
            memberPayment: memberPayments[j],
          })
        }
      }
    } catch (e) {
      console.log('Error getting memberPayments', e)
    } finally {
      context.commit('setLoading', { key: 'getMemberPayments', value: false })
    }
  },
  async getFuturePastPayments(context, variables) {
    try {
      context.commit('clearData')
      context.commit('setLoading', {
        key: 'getFuturePastMemberPayments',
        value: true,
      })

      const query = await getGraphql('my-past-future-payments.graphql')
      const response = await this.$axios.$post('/GRAPHQL_URL/', {
        query,
        variables,
      })

      // parse individual memberPayments
      const futureMemberPayments = response.data.me.futurePayments
      const pastMemberPayments = response.data.me.pastPayments
      context.commit(
        'setFuturePayout',
        futureMemberPayments.length > 0 ? futureMemberPayments[0] : undefined
      )
      if (futureMemberPayments && futureMemberPayments.length > 0) {
        for (let j = 0; j < futureMemberPayments.length; j++) {
          context.commit('addFuturePayment', {
            memberPayment: futureMemberPayments[j],
          })
        }
      }
      if (pastMemberPayments && pastMemberPayments.length > 0) {
        for (let j = 0; j < pastMemberPayments.length; j++) {
          context.commit('addPastPayment', {
            memberPayment: pastMemberPayments[j],
          })
        }
      }
    } catch (e) {
      console.log('Error getting futurePastMemberPayments', e)
    } finally {
      context.commit('setLoading', {
        key: 'getFuturePastMemberPayments',
        value: false,
      })
    }
  },

  async getStripeIssuingBalance(context) {
    try {
      context.commit('clearData')
      context.commit('setLoading', {
        key: 'getStripeIssuingBalance',
        value: true,
      })

      const query = await getGraphql('query-stripe-issuing-balance.graphql')
      const response = await this.$axios.$post('/GRAPHQL_URL/', {
        query,
      })

      // parse individual memberPayments
      const stripeIssuingBalance =
        response?.data?.me?.funds?.stripeIssuingBalance?.realtimeIssuingBalance
      context.commit('setStripeIssuingBalance', stripeIssuingBalance)
    } catch (e) {
      console.log('Error getting stripeIssuingBalance', e)
    } finally {
      context.commit('setLoading', {
        key: 'getStripeIssuingBalance',
        value: false,
      })
    }
  },
  async selectPayment({ commit, getters }, variables) {
    try {
      commit('clearSelectedMemberPayment')
      commit('setLoading', {
        key: 'getSelectedMemberPayments',
        value: true,
      })

      let payment = getters.getPaymentByUuid(variables.memberPaymentUuid)

      if (!payment) {
        // pull payment from backend
        const query = await getGraphql('query-member-payments.graphql')
        const response = await this.$axios.$post('/GRAPHQL_URL/', {
          query,
          variables,
        })
        payment = response.data.me.memberPayment ?? undefined
      }

      // parse individual memberPayments
      commit('setSelectedPayout', payment)
    } catch (e) {
      console.log('Error getting selectedMemberPayments', e)
    } finally {
      commit('setLoading', {
        key: 'getSelectedMemberPayments',
        value: false,
      })
    }
  },

  async getUsioEntityPayment({ commit }) {
    commit('setLoading', {
      key: 'getUsioEntityPayment',
      value: true,
    })

    try {
      const query = await getGraphql('query-get-usio-entity-payment.graphql')
      const response = await this.$axios.$post('/GRAPHQL_URL/', {
        query,
      })
      const entityPayment = response.data.me.payouts.usio.entityPayment

      commit('setUsioEntityPayment', entityPayment)

      return entityPayment
    } catch (e) {
      console.log('Error getting usioEntityPayment', e)
    } finally {
      commit('setLoading', {
        key: 'getUsioEntityPayment',
        value: false,
      })
    }
  },

  async setupUsioEntityPayment({ commit }) {
    commit('setLoading', {
      key: 'setupUsioEntityPayment',
      value: true,
    })

    try {
      const query = await getGraphql(
        'mutation-setup-usio-entity-payment.graphql'
      )
      const response = await this.$axios.$post('/GRAPHQL_URL/', {
        query,
      })

      return response.data.me.payouts.createUsioAccount
    } catch (e) {
      console.log('Error setting up usioEntityPayment', e)
    } finally {
      commit('setLoading', {
        key: 'setupUsioEntityPayment',
        value: false,
      })
    }
  },

  async completeUsioEntityPayment({ commit }, variables) {
    commit('setLoading', {
      key: 'completeUsioEntityPayment',
      value: true,
    })

    try {
      const query = await getGraphql(
        'mutation-complete-usio-entity-payment.graphql'
      )
      const response = await this.$axios.$post('/GRAPHQL_URL/', {
        query,
        variables,
      })

      return response.data.me.payouts.collectVirtualCard
    } catch (e) {
      console.log('Error setting up usioEntityPayment', e)
    } finally {
      commit('setLoading', {
        key: 'completeUsioEntityPayment',
        value: false,
      })
    }
  },

  async fetchAccountLogin({ commit }) {
    commit('setLoading', {
      key: 'fetchAccountLogin',
      value: true,
    })

    try {
      const query = await getGraphql(
        'query-me-payouts-usio-account-login.graphql'
      )
      const response = await this.$axios.$post('/GRAPHQL_URL/', {
        query,
      })

      const errors = response.errors

      if (errors && errors.length > 0) {
        commit('setAccountLogin', {})
        return {}
      }

      const accountLogin = get(
        response,
        ['data', 'me', 'payouts', 'usio', 'accountLogin'],
        {}
      )

      commit('setAccountLogin', accountLogin)

      return accountLogin
    } catch (e) {
      commit('setAccountLogin', {})
      console.log('Error fetching account login', e)
    } finally {
      commit('setLoading', {
        key: 'fetchAccountLogin',
        value: false,
      })
    }
  },
}

export const getters = {
  findNextPayment: () => (payments, locale) => {
    let paymentDate = ''
    const options = {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    }
    const localeString = locale.toLowerCase() === 'es' ? 'es-US' : 'en-US'
    if (payments) {
      for (let i = 0; i < payments.length; i++) {
        if (
          payments[i].paymentStatusId === 1 &&
          new Date() < new Date(payments[i].datePaymentFulfilled)
        ) {
          paymentDate = payments[i].datePaymentFulfilled
          break
        }
      }
      if (paymentDate.length) {
        paymentDate = new Date(paymentDate).toLocaleDateString(
          localeString,
          options
        )
      }
    }
    return paymentDate
  },

  getPaymentByUuid: (state) => (memberPaymentUuid) => {
    try {
      const allPayments = [
        ...state.pastPayments,
        ...state.futurePayments,
        ...state.memberPayments,
      ]
      return allPayments.find(
        (item) => item.memberPaymentUuid === memberPaymentUuid
      )
    } catch (error) {
      return undefined
    }
  },
}
